/**
 * Hero portfolio — template-home.
 * Intro animations: all viewports. Parallax/hover: desktop layered layout only.
 */
(function () {
	'use strict';

	var STACK_MAX = 1023;
	var EASE_OUT = 'cubic-bezier(0.25, 1, 0.5, 1)';

	var mqDesktop = window.matchMedia('(min-width: ' + (STACK_MAX + 1) + 'px)');
	var mqFinePointer = window.matchMedia('(hover: hover) and (pointer: fine)');

	function byW(id) {
		return document.querySelector('[data-w-id="' + id + '"]');
	}

	function wa(el, keyframes, options) {
		if (!el || typeof el.animate !== 'function') {
			return Promise.resolve();
		}

		return el.animate(keyframes, options).finished.catch(function () {});
	}

	function isDesktopLayout() {
		return mqDesktop.matches;
	}

	function isFinePointer() {
		return mqFinePointer.matches;
	}

	function addWebflowClasses() {
		var html = document.documentElement;

		if (html.className.indexOf('w-mod-js') === -1) {
			html.className += ' w-mod-js';
		}

		if (
			('ontouchstart' in window || (window.DocumentTouch && document instanceof DocumentTouch)) &&
			html.className.indexOf('w-mod-touch') === -1
		) {
			html.className += ' w-mod-touch';
		}
	}

	function runIntroLoad() {
		var tasks = [
			wa(
				byW('5dd49879-bb6d-9761-6b9f-99ef10e8ed50'),
				[
					{ transform: 'translate3d(100%, 0, 0)' },
					{ transform: 'translate3d(0, 0, 0)' },
				],
				{ delay: 500, duration: 2000, easing: EASE_OUT, fill: 'forwards' }
			),
			wa(
				byW('8eac85f7-1afe-c8e0-48bc-0a52a4b25563'),
				[
					{ transform: 'translate3d(-120%, 0, 0)', opacity: 0 },
					{ transform: 'translate3d(0, 0, 0)', opacity: 1 },
				],
				{ delay: 500, duration: 3000, easing: EASE_OUT, fill: 'forwards' }
			),
			wa(
				byW('918f980a-0561-03d6-d64a-8d6a25ce224e'),
				[
					{ transform: 'translate3d(0, calc(var(--dma_font_size_30) * -2.2), 0)' },
					{ transform: 'translate3d(0, 0, 0)' },
				],
				{ delay: 500, duration: 1000, easing: EASE_OUT, fill: 'forwards' }
			),
			wa(
				byW('918f980a-0561-03d6-d64a-8d6a25ce225b'),
				[
					{ transform: 'scale3d(0.2, 0.2, 1)', opacity: 0 },
					{ transform: 'scale3d(1, 1, 1)', opacity: 0.6 },
				],
				{ delay: 1000, duration: 1000, easing: EASE_OUT, fill: 'forwards' }
			),
			wa(
				byW('918f980a-0561-03d6-d64a-8d6a25ce225c'),
				[
					{ transform: 'scale3d(0.2, 0.2, 1)', opacity: 0 },
					{ transform: 'scale3d(1, 1, 1)', opacity: 0.5 },
				],
				{ delay: 1200, duration: 1000, easing: EASE_OUT, fill: 'forwards' }
			),
			wa(
				byW('918f980a-0561-03d6-d64a-8d6a25ce2256'),
				[
					{ transform: 'translate3d(-100%, 0, 0)' },
					{ transform: 'translate3d(0, 0, 0)' },
				],
				{ delay: 1200, duration: 2000, easing: EASE_OUT, fill: 'forwards' }
			),
			wa(
				byW('918f980a-0561-03d6-d64a-8d6a25ce225d'),
				[
					{ transform: 'scale3d(0.2, 0.2, 1)', opacity: 0 },
					{ transform: 'scale3d(1, 1, 1)', opacity: 0.4 },
				],
				{ delay: 1400, duration: 1000, easing: EASE_OUT, fill: 'forwards' }
			),
			wa(
				byW('918f980a-0561-03d6-d64a-8d6a25ce225a'),
				[
					{ transform: 'scale3d(0.2, 0.2, 1)', opacity: 0 },
					{ transform: 'scale3d(1, 1, 1)', opacity: 0.5 },
				],
				{ delay: 1600, duration: 1000, easing: EASE_OUT, fill: 'forwards' }
			),
			wa(
				byW('dcd55a3d-d607-333d-57a0-046353cdf060'),
				[
					{ transform: 'translate3d(0, var(--dma_space_16), 0)', opacity: 0 },
					{ transform: 'translate3d(0, 0, 0)', opacity: 1 },
				],
				{ delay: 2000, duration: 1000, easing: EASE_OUT, fill: 'forwards' }
			),
			wa(byW('8d57ad6c-62ec-f861-a23d-abc80ad9be26'), [{ opacity: 0 }, { opacity: 1 }], {
				delay: 2200,
				duration: 500,
				easing: 'ease-out',
				fill: 'forwards',
			}),
			wa(
				byW('5d5055c2-e474-3228-4701-1f081e6fbf37'),
				[
					{ transform: 'translate3d(0, var(--dma_space_16), 0)', opacity: 0 },
					{ transform: 'translate3d(0, 0, 0)', opacity: 1 },
				],
				{ delay: 2400, duration: 1000, easing: EASE_OUT, fill: 'forwards' }
			),
		];

		var ghost2251 = byW('918f980a-0561-03d6-d64a-8d6a25ce2251');

		if (ghost2251) {
			tasks.push(
				wa(ghost2251, [{ opacity: 0 }, { opacity: 1 }], {
					delay: 500,
					duration: 2000,
					easing: 'ease-out',
					fill: 'forwards',
				})
			);
		}

		return Promise.all(tasks);
	}

	function resetPhotoTransform(photo) {
		if (!photo) {
			return;
		}

		photo.style.transform = isDesktopLayout() ? 'translateX(-50%)' : '';
	}

	function setupPhotoParallax() {
		var photo = byW('1ab57201-c476-c2b0-7aa9-86f41b75eb30');

		if (!photo) {
			return;
		}

		var tx = 0.5;
		var ty = 0.5;
		var mx = 0.5;
		var my = 0.5;
		var raf = 0;
		var active = false;

		function frame() {
			raf = 0;

			if (!active) {
				return;
			}

			mx += (tx - mx) * 0.12;
			my += (ty - my) * 0.12;
			photo.style.transform =
				'translate3d(calc(-50% + ' + (-3 + mx * 6) + 'vw), ' + (-1 + my * 2) + 'vh, 0)';
		}

		function schedule() {
			if (active && !raf) {
				raf = requestAnimationFrame(frame);
			}
		}

		function onMove(e) {
			tx = e.clientX / window.innerWidth;
			ty = e.clientY / window.innerHeight;
			schedule();
		}

		function enable() {
			if (active) {
				return;
			}

			active = true;
			window.addEventListener('mousemove', onMove, { passive: true });
			frame();
		}

		function disable() {
			active = false;
			window.removeEventListener('mousemove', onMove);
			resetPhotoTransform(photo);
		}

		function sync() {
			if (isDesktopLayout() && isFinePointer()) {
				enable();
			} else {
				disable();
			}
		}

		mqDesktop.addEventListener('change', sync);
		mqFinePointer.addEventListener('change', sync);
		window.addEventListener('resize', schedule, { passive: true });
		sync();
	}

	function setupPhotographerHover() {
		var photoLink = document.querySelector('.hero-ptfl-link-photo');
		var first = document.querySelector('.hero-ptfl-link--first');
		var second = document.querySelector('.hero-ptfl-link--second');

		if (!photoLink || !first || !second) {
			return;
		}

		var dur = '0.45s';
		var bound = false;

		function enter() {
			photoLink.style.transition = 'color ' + dur + ' ease';
			photoLink.style.color = 'rgb(27, 27, 27)';
			first.style.transition = 'opacity ' + dur + ' ease';
			second.style.transition = 'opacity ' + dur + ' ease';
			first.style.opacity = '0';
			second.style.opacity = '1';
		}

		function leave() {
			photoLink.style.transition = 'color ' + dur + ' ease';
			photoLink.style.color = 'rgba(0, 0, 0, 0)';
			first.style.transition = 'opacity ' + dur + ' ease';
			second.style.transition = 'opacity ' + dur + ' ease';
			first.style.opacity = '1';
			second.style.opacity = '0';
		}

		function bind() {
			if (bound) {
				return;
			}

			photoLink.addEventListener('mouseenter', enter);
			photoLink.addEventListener('mouseleave', leave);
			bound = true;
		}

		function unbind() {
			if (!bound) {
				return;
			}

			photoLink.removeEventListener('mouseenter', enter);
			photoLink.removeEventListener('mouseleave', leave);
			first.style.opacity = '';
			second.style.opacity = '';
			photoLink.style.color = '';
			bound = false;
		}

		function sync() {
			if (isDesktopLayout() && isFinePointer()) {
				bind();
			} else {
				unbind();
			}
		}

		mqDesktop.addEventListener('change', sync);
		mqFinePointer.addEventListener('change', sync);
		sync();
	}

	function setupWebOutlineSync() {
		var triggers = document.querySelectorAll('.hero-ptfl-link-photo');
		var webLinks = document.querySelectorAll('.hero-ptfl-link-web');

		if (!triggers.length || !webLinks.length) {
			return;
		}

		function addOutline() {
			webLinks.forEach(function (link) {
				link.classList.add('is--outline-text');
			});
		}

		function removeOutline() {
			webLinks.forEach(function (link) {
				link.classList.remove('is--outline-text');
			});
		}

		triggers.forEach(function (trigger) {
			trigger.addEventListener('mouseover', addOutline);
			trigger.addEventListener('mouseout', removeOutline);
		});
	}

	function setupDesktopInteractions() {
		if (!isDesktopLayout() || !isFinePointer()) {
			return;
		}

		setupPhotoParallax();
		setupPhotographerHover();
		setupWebOutlineSync();
	}

	function onDomReady(fn) {
		if (document.readyState === 'loading') {
			document.addEventListener('DOMContentLoaded', fn);
			return;
		}

		fn();
	}

	function onLoad(fn) {
		if (document.readyState === 'complete') {
			fn();
			return;
		}

		window.addEventListener('load', fn);
	}

	function initHeroPortfolio() {
		if (!document.querySelector('.hero-ptfl-section')) {
			return;
		}

		addWebflowClasses();

		onDomReady(setupDesktopInteractions);
		onLoad(runIntroLoad);
	}

	initHeroPortfolio();
})();
